import React from "react";
import website_about_us from "../../assets/web_about.png";
const About = () => {
  const key_points = [
    "Clear Understanding of Client Needs",
    "Effective Communication",
    "User-Centric Design",
    "Mobile Responsiveness",
    "Cross-Browser Compatibility",
    "SEO-Friendly Structure",
    "Fast Loading Speed",
    "Security Measures",
    "Scalability",
    "Quality Assurance Testing",
    "Content Management System (CMS) Integration",
    "Regular Updates and Maintenance",
    "Transparent Pricing",
    "Industry Expertise"
  ]
  return (
    <div
      className="flex-col sm:flex-row flex justify-between px-5 sm:px-20 sm:my-10"
      id="about"
    >
      <div className="sm:w-[40%] w-full">
        <img
          className="w-full h-[21rem] object-contain"
          src={website_about_us}
        />
      </div>
      <div className="w-full sm:w-[60%]">
        <p className="font-notosans text-2xl sm:text-2xl font-bold text-[#333e49]">
          Why Our Commitment to Exceptional Service Sets Us Apart for Our
          Clients.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 justify- mt-4">
          {
            key_points.map(item => 
              
          <span className="flex my-1 font-notosans font-semibold text-slate-800" key={item}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            &nbsp;
            {item}
          </span>
              
              )
          }

          
        </div>
      </div>
    </div>
  );
};

export default About;
